/**
 * AEM is delivering boolean in different formats on different ENVs so we have to support both some time
 * @param value string or boolean
 * @returns boolean
 */
export const isTrue = (value: string | boolean): boolean => {
  return typeof value === 'string' ? value === 'true' : value;
};
